//====================================================
//  Initialization Tabs
//====================================================
function fn_components_tabs(){
	fn_tabs();
}

function fn_tabs(){
	if ($('.tabs').length){
		$( ".tabs .item" ).click(function() {
			var inst = $(this);
			var thisId = inst.attr('id');
			var thisTabs = $(this).closest('.tab-block');

			if(thisId == 'undefined'){
				return false;
			}
			
			if (!inst.hasClass('active')){
				thisTabs.find( ".tabs .item" ).each(function(){
					$(this).closest('.item').removeClass('active');
				});
				$(this).closest('.item').addClass('active');
				thisTabs.find(" .tabs-content .item-block" ).each(function(){
					$(this).removeClass('active');
				});
				thisTabs.find('.tabs-content .item-block[data-id="'+ thisId + '"]').addClass('active');
			}
		});
	}

	if ($('.js-tabs-list').length){
		$( ".js-tabs-list .js-tab-item" ).click(function() {
			var inst = $(this);
			var thisId = inst.attr('id');
			var thisTabs = $(this).closest('.js-tab-block');
			var tabContent = thisTabs.find('.js-tabs-content');

			if(thisId == 'undefined'){
				return false;
			}


			if (!inst.hasClass('active')){
				thisTabs.find( ".js-tab-item" ).each(function(){
					$(this).removeClass('active');
				});
				$(this).addClass('active');

				thisTabs.find(" .js-tabs-content .js-tabs-content-item" ).each(function(){
					$(this).removeClass('active');
				});
				thisTabs.find('.js-tabs-content .js-tabs-content-item[data-id="'+ thisId + '"]').addClass('active');
				
				tabContent.remove();

				if ($(window).width() > 760){
					var resultRow;
					var row = thisId.substring(thisId.lastIndexOf("-") + 1);
					if (row <= 5){
						resultRow = 5;
					} else if (row >= 6 && row <= 10){
						resultRow = 10;
					} else if (row >= 11 && row <= 15){
						resultRow = 15
					} else if (row >= 16 && row <= 20){
						resultRow = 20;
					} else if (row >= 21 && row <= 25){
						resultRow = 25;
					} else if (row >= 26 && row <= 30){
						resultRow = 30;
					}

					if ($('.js-tabs-list .js-tab-item:nth-child(' + resultRow + ')').length){
						$('.js-tabs-list .js-tab-item:nth-child(' + resultRow + ')').after(tabContent);
					} else {
						$('.js-tabs-list .js-tab-item:last-child()').after(tabContent);
					}

				}

				if ($(window).width() <= 760 && $(window).width() > 550){
					var resultRow;
					var row = thisId.substring(thisId.lastIndexOf("-") + 1);

					if (row <= 3){
						resultRow = 3;
					} else if (row >= 4 && row <= 6){
						resultRow = 6;
					} else if (row >= 7 && row <= 9){
						resultRow = 9
					} else if (row >= 10 && row <= 12){
						resultRow = 12;
					} else if (row >= 13 && row <= 15){
						resultRow = 15;
					} else if (row >= 16 && row <= 18){
						resultRow = 18;
					} else if (row >= 19 && row <= 21){
						resultRow = 21;
					} else if (row >= 22 && row <= 24){
						resultRow = 24;
					} else if (row >= 25 && row <= 27){
						resultRow = 27;
					} else if (row >= 28 && row <= 30){
						resultRow = 30;
					}

					if ($('.js-tabs-list .js-tab-item:nth-child(' + resultRow + ')').length){
						$('.js-tabs-list .js-tab-item:nth-child(' + resultRow + ')').after(tabContent);
					} else {
						$('.js-tabs-list .js-tab-item:last-child()').after(tabContent);
					}
				} 

				if ($(window).width() <= 550){
					var resultRow;
					var row = thisId.substring(thisId.lastIndexOf("-") + 1);

					if (row <= 2){
						resultRow = 2;
					} else if (row >= 3 && row <= 4){
						resultRow = 4;
					} else if (row >= 5 && row <= 6){
						resultRow = 6
					} else if (row >= 7 && row <= 8){
						resultRow = 8;
					} else if (row >= 9 && row <= 10){
						resultRow = 10;
					} else if (row >= 11 && row <= 12){
						resultRow = 12;
					} else if (row >= 13 && row <= 14){
						resultRow = 14;
					} else if (row >= 15 && row <= 16){
						resultRow = 16;
					} else if (row >= 17 && row <= 18){
						resultRow = 18;
					} else if (row >= 19 && row <= 20){
						resultRow = 20;
					} else if (row >= 21 && row <= 22){
						resultRow = 22;
					} else if (row >= 23 && row <= 24){
						resultRow = 24;
					} else if (row >= 25 && row <= 26){
						resultRow = 26;
					} else if (row >= 27 && row <= 28){
						resultRow = 28;
					} else if (row >= 29 && row <= 30){
						resultRow = 30;
					}

					if ($('.js-tabs-list .js-tab-item:nth-child(' + resultRow + ')').length){
						$('.js-tabs-list .js-tab-item:nth-child(' + resultRow + ')').after(tabContent);
					} else {
						$('.js-tabs-list .js-tab-item:last-child()').after(tabContent);
					}


				}
				fn_dots('.js-tabs-content-item.active .dots');

			} else {
				$(this).removeClass('active');
				$(" .js-tabs-content .js-tabs-content-item.active" ).removeClass('active');
			}
		});
	}
}

